<script>
    import KeyValueTable from "./KeyValueTable.svelte";
    export let data;
    export let key = undefined;
    export let includedRows = undefined;

    $: response = (data || {}).response || {};
    $: layers = response.layers || [];
    $: layer = key ? layers.find(l => l.name === key) || {} : layers[0];

    function isNotInternal(cell) {
        return !cell.name.startsWith('INTERNAL_');
    }

    $: rows = layer.rows || [];
    $: firstRow = rows[0] || {};
    $: columns = firstRow.columns || [];

    $: isDisplayed = Array.isArray(includedRows)
        ? cell => isNotInternal(cell) && includedRows.includes(cell.name)
        : isNotInternal;
</script>

<KeyValueTable {columns} {rows} {isDisplayed} >
    <slot></slot>
</KeyValueTable>
